import { render, staticRenderFns } from "./create_user.vue?vue&type=template&id=40a3426a&scoped=true&"
import script from "./create_user.vue?vue&type=script&lang=js&"
export * from "./create_user.vue?vue&type=script&lang=js&"
import style0 from "./create_user.vue?vue&type=style&index=0&id=40a3426a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a3426a",
  null
  
)

export default component.exports